export default {
  getBankOperations: (state) => state.bankOperations,
  getBankOperation: (state) => (id) => {
    return state.bankOperations.find(bankOperation => bankOperation.id === parseInt(id))
  },
  getEmptyBankOperation: (state) => JSON.parse(JSON.stringify(state.emptyBankOperation)),
}